import { AccountConstants } from 'modules/layout/store/constants';
import { RequestAction } from '@redux-requests/core';
import { AppsConstants } from 'modules/userApps/store/constants';
import { gql } from '@redux-requests/graphql';

export interface IEditPlan {
  id: string;
  plan: 'CLASSIC' | 'PREMIUM' | 'ENTERPRISE';
}

export const editAppPlan = ({ id, plan }: IEditPlan): RequestAction => ({
  type: AccountConstants.EDIT_APP_PLAN,
  request: {
    query: gql`
      mutation($id: ID, $plan: CompanyPlan) {
        saveApp(app: { id: $id, plan: $plan }) {
          id
          plan
        }
      }
    `,
    variables: {
      id,
      plan,
    },
  },
  meta: {
    requestKey: id,
    mutations: {
      [AppsConstants.APP + id]: (data, { saveApp }) => ({ ...data, ...saveApp }),
    },
  },
});
